import React, { Component, Fragment } from 'react' 
import '../../../../public/css/suplier.css';
import { do_action } from '../../actions';
import Pagination from '../Common/Pagination';
import {
    BASE_URL_ADMIN
} from '../../data/config';
class Suplier extends Component {
    constructor(props) {
        super(props)
        this.state = {
            suppliers: [],
            categories: [],
            category_id: null,
            page: 1,
            numb_per_page: 9,
            number_page: 1,
            id: '',
            current_page: 1,
            childs: []
        }
    }
    componentWillMount = () => {
        this.initData(this.state.page);
        this.initJquery();
    }

    componentDidUpdate = () => {
        this.initJquery();
    }
    initData(page) {
        var self = this;
        loadData();
        function loadData() {
            loadSupplierCategories();
            function loadSupplierCategories() {
                do_action('get_supplier_categories')
                .then(res => {
                    if (res.code == "SUCCESS") {
                        var categories = res.data;
                        var category_id_default = categories.length > 0 ? categories[0]._id : null;
                        self.setState({ categories });

                        self.getSupplier(page, category_id_default);
                    }
                })
                .catch(err => console.log(err));
            }
        }
        
    }
    initJquery() {
        // let self = this;
        // $(document).ready(function($) {
        //     $("body").delegate('.list-category-supplier .parent-menu', 'click', function (event) {
        //         $(this).parent().find('.submenu').toggleClass('hidden');
        //     });
        // });
        $(document).ready(function($) {
            $('.list-category-supplier > li').each(function(e) {
                $(this).find('.parent-menu').click(function(event) {
                    var a = $(this).parents('.list-category-supplier').find('.active').removeClass('active');
                    $(this).addClass('active');
                });
            });
            $('.list-category-supplier .submenu1 > li').each(function(e) {
                $(this).find('.child-menu-1').click(function(event) {
                    var a = $(this).parents('.list-category-supplier').find('.active').removeClass('active');
                    $(this).addClass('active');
                    $(this).parent().parent().parent().find('.parent-menu').addClass('active');
                });
            });
            $('.list-category-supplier .submenu2 > li').each(function(e) {
                $(this).find('.child-menu-2').click(function(event) {
                    var a = $(this).parents('.list-category-supplier').find('.active').removeClass('active');
                    $(this).addClass('active');
                    $(this).parent().parent().parent().find('.child-menu-1').addClass('active');
                    $(this).parent().parent().parent().parent().parent().find('.parent-menu').addClass('active');
                });
            });
        });
    }
    renderCategories(){
        return this.state.categories.map((category, index) => {
            let listSubmenu = category.childs;
            return (
                <li key={category._id} >
                    <a data={category._id} className={(this.state.category_id == category._id) ? 'parent-menu active' : 'parent-menu'} onClick={this.handleMenuSupplier.bind(this, category._id)}>{category.name}</a>
                    {listSubmenu.length > 0 ? (
                        <ul className="list-unstyled list-category submenu submenu1">
                            {listSubmenu.map((submenu, i) => {
                                let listSubmenu2 = submenu.childs;
                                return <li key={submenu._id}>
                                        <a data={submenu._id} className={(this.state.category_id == submenu._id) ? 'active child-menu-1' : 'child-menu-1'} onClick={this.handleMenuSupplier.bind(this, submenu._id)}>{submenu.name}</a>
                                        {listSubmenu2.length > 0 ? (
                                            <ul className="list-unstyled list-category submenu submenu2">
                                                {listSubmenu2.map((submenu2, i) => {
                                                    return <li key={submenu2._id}>
                                                        <a data={submenu2._id} className={(this.state.category_id == submenu2._id) ? 'active child-menu-2' : 'child-menu-2'} onClick={this.handleMenuSupplier.bind(this, submenu2._id)}>{submenu2.name}</a>
                                                        </li>
                                                })}
                                            </ul>
                                        ) : (
                                            null
                                        )}    
                                    </li>
                            })}
                        </ul>
                    ) : (
                        null
                    )}
                </li>
            );
        })
    } 
    handleMenuSupplier(category_id, e) {
        e.preventDefault();
        this.getSupplier(1, category_id);
        
    }
    renderSuppliers(){
        return this.state.suppliers.map((supplier, index) => {
            let url_img;
            let logo;

            if (supplier.banner) {
                url_img = BASE_URL_ADMIN + supplier.banner;
            }
            else {
                url_img = '/images/NoPhoto.jpg';
            }

            if (supplier.logo) {
                logo = BASE_URL_ADMIN + supplier.logo;
            }
            else {
                logo = '/images/NoPhoto.jpg';
            }
            return (
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4" key={index}>
                    <div className="item-supplier item-hover">
                        <div className="img-supplier">
                            <a href={'/supplier/'+supplier.post_slug}><img src={url_img} alt="Ruhu Suplier" /></a>
                        </div>
                        <div className="info-supplier">
                            <div className="logo-suplier">
                                <img src={logo} alt="Ruhu Suplier"/>
                            </div>
                            <div className="info-detail">
                                <div className="name"><a href={'/supplier/'+supplier.post_slug}>{supplier.name}</a></div>
                                <div className="cate">
                                    {supplier.category.parent != null ? (
                                        <span>{supplier.category.parent_name}</span>
                                    ) : (
                                        null
                                    )}
                                    
                                    <span>{supplier.category.name}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        })
    }
    clickPage(page) {
        this.getSupplier(page, this.state.category_id);
        window.scrollTo(0, 0);
    }
    getSupplier(page, category_id) {
        var self = this;
        var { numb_per_page } = this.state;
        do_action('get_suppliers_by_category', { page , numb_per_page, id: category_id })
            .then(res => {
                if (res.code == "SUCCESS") {
                    var suppliers = res.data;
                    var number_page = res.number_page;
                    var current_page = res.current_page;
                    self.setState({ suppliers, number_page, page, current_page, category_id });
                }
            })
            .catch(err => console.log(err));
    }
    render() {
        let { suppliers, page, number_page } = this.state;
        return (
            <Fragment>
                <div id="suplier" className="suplier contractor-content">
                    <div className="main-content">
                        <div className="container ">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                    <div className="sidebar">
                                        <h3 className="marginT0 tit">Catergories</h3>
                                        <ul className="list-unstyled list-category list-category-supplier">
                                            {this.renderCategories()}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 content">
                                    <div className="block-design-your-house form-group">
                                        <img src={'/images/supplier.jpg'} className="img" alt="Ruhu"/>
                                    </div>
                                    {/*<h3>Recommended Company</h3>*/}
                                    <div className="row">
                                        {this.renderSuppliers()}
                                    </div>
                                    <Pagination page={page} number_page={number_page} clickPage={this.clickPage.bind(this)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Suplier